import { OverallStatus } from "../../utils/derivePeppolStatus";
import { isSimplifiedTransactionType } from "./isSimplifiedTransactionType";

const IN_FLIGHT_STATUSES = [
  OverallStatus.VALIDATION_FAILED,
  OverallStatus.PENDING_TRANSMISSION,
  OverallStatus.VALIDATING,
  OverallStatus.TRANSMITTING,
  OverallStatus.PENDING,
];

export const getArchiveXmlActionState = (row) => {
  const overallStatus =
    row?.meta_info?.peppol_status?.overall_status ?? OverallStatus.PENDING;
  const allowArchiveXml = !IN_FLIGHT_STATUSES.includes(overallStatus);
  const archiveXmlDisabledReason =
    overallStatus === OverallStatus.VALIDATION_FAILED
      ? "Unavailable when Peppol validation failed"
      : "Unavailable until Peppol processing completes";

  return {
    allowArchiveXml,
    archiveXmlDisabledReason,
    showDocumentMls: !isSimplifiedTransactionType(row?.transaction_type),
  };
};
